// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".CreateSocialItem-cls1___e03a847de6b3d65f420{/*!*/}.CreateSocialItem-cls2___669c523fc15adb3105a{width:100%;border-bottom:1px solid #dddde2}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "CreateSocialItem-cls1___e03a847de6b3d65f420",
	"cls2": "CreateSocialItem-cls2___669c523fc15adb3105a CreateSocialItem-cls1___e03a847de6b3d65f420"
};
export default ___CSS_LOADER_EXPORT___;
